import {
  TREQUEST_AvailableLocationsListing,
  TREQUEST_ConfirmItemsTransfer,
  TREQUEST_GetNewLocationDetails,
  TREQUEST_ItemsStoredInLocationDetails,
  TRESPONSE_AvailableLocationsListing,
  TRESPONSE_ConfirmItemsTransfer,
  TRESPONSE_GetNewLocationDetails,
  TRESPONSE_ItemsStoredInLocationDetails,
} from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum TransferDBActions {
  ClearAndFetchAvailableLocationsListing = 'ClearAndFetchAvailableLocationsListing',
  ClearAndFetchAvailableLocationsListingSuccess = 'ClearAndFetchAvailableLocationsListingSuccess',
  ClearAndFetchItemsStoredInLocationDetails = 'ClearAndFetchItemsStoredInLocationDetails',
  ClearAndFetchItemsStoredInLocationDetailsSuccess = 'ClearAndFetchItemsStoredInLocationDetailsSuccess',
  GetNewLocationDetails = 'GetNewLocationDetails',
  GetNewLocationDetailsSuccess = 'GetNewLocationDetailsSuccess',
  ConfirmItemsTransfer = 'ConfirmItemsTransfer',
  ConfirmItemsTransferSuccess = 'ConfirmItemsTransferSuccess',

  TransferNoAction = 'TransferNoAction',
}

export class ClearAndFetchAvailableLocationsListing implements Action {
  readonly type = TransferDBActions.ClearAndFetchAvailableLocationsListing;
  constructor(public payload: TREQUEST_AvailableLocationsListing) {}
}

export class ClearAndFetchAvailableLocationsListingSuccess implements Action {
  readonly type = TransferDBActions.ClearAndFetchAvailableLocationsListingSuccess;
  constructor(public res: TRESPONSE_AvailableLocationsListing) {}
}

export class ClearAndFetchItemsStoredInLocationDetails implements Action {
  readonly type = TransferDBActions.ClearAndFetchItemsStoredInLocationDetails;
  constructor(public payload: TREQUEST_ItemsStoredInLocationDetails) {}
}

export class ClearAndFetchItemsStoredInLocationDetailsSuccess implements Action {
  readonly type = TransferDBActions.ClearAndFetchItemsStoredInLocationDetailsSuccess;
  constructor(public res: TRESPONSE_ItemsStoredInLocationDetails) {}
}

export class GetNewLocationDetails implements Action {
  readonly type = TransferDBActions.GetNewLocationDetails;
  constructor(public payload: TREQUEST_GetNewLocationDetails) {}
}

export class GetNewLocationDetailsSuccess implements Action {
  readonly type = TransferDBActions.GetNewLocationDetailsSuccess;
  constructor(public res: TRESPONSE_GetNewLocationDetails) {}
}

export class ConfirmItemsTransfer implements Action {
  readonly type = TransferDBActions.ConfirmItemsTransfer;
  constructor(public payload: TREQUEST_ConfirmItemsTransfer) {}
}

export class ConfirmItemsTransferSuccess implements Action {
  readonly type = TransferDBActions.ConfirmItemsTransferSuccess;
  constructor(public res: TRESPONSE_ConfirmItemsTransfer) {}
}

export class TransferNoAction implements Action {
  readonly type = TransferDBActions.TransferNoAction;
  constructor() {}
}

export type TTransferActionTypes =
  | ClearAndFetchAvailableLocationsListing
  | ClearAndFetchAvailableLocationsListingSuccess
  | ClearAndFetchItemsStoredInLocationDetails
  | ClearAndFetchItemsStoredInLocationDetailsSuccess
  | GetNewLocationDetails
  | GetNewLocationDetailsSuccess
  | ConfirmItemsTransfer
  | ConfirmItemsTransferSuccess
  | TransferNoAction;
